module.exports = __webpack_public_path__ + "img/fk.e51a7445.svg";